import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {Grid, FormControl, MenuItem, IconButton }from "@material-ui/core";
import translate from '../other/translate.json';
import clsx from 'clsx';
import config from '../other/config';
import DoneIcon from '@material-ui/icons/Done';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import { Close, Feedback } from '@material-ui/icons';
import utils from '../other/utils';
import CustomSelectBank from './CustomSelectBank'
import CustomAutocomplete from './CustomAutocomplete'
const { serverAPI } = config;


const CustomTypography = withStyles((theme) => ({
  h1: {
    fontSize: '40px',
    lineHeight: '48px',
    fontWeight: '500',
    color: '#24262A'
  },

  body1: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '400',
    color: '#8987A2'
  },

  gutterBottom: {
    marginBottom: 20
  },
}))(Typography);

export default function KloBanksChoose(props) {
  const classes = useStyles();
  const {kloStatus,codeasvul,kloUser, _kloUser} = props
  //const kloStatus = props.kloStatuses && props.kloStatuses[props.data.codeasvul] ? props.kloStatuses[props.data.codeasvul] : '';	
  const saveFeedback = (feedback) => {
    _kloUser((prevstate) => {return { ...prevstate, /*['hasFeedback']:true,*/ ['newFeedBack'] :feedback }})
  }
  


  
	
  const MainContainer = document.getElementById('MainContainer');
  let pagination = document.getElementById('pagination2-js') || document.getElementById('pagination-js')
  let delta =  pagination !== null ? pagination.getBoundingClientRect().width : props.delta || 343 ;
  
  const width = MainContainer !== null ? MainContainer.getBoundingClientRect().width - delta : undefined//(props.delta || 343): undefined;
  //console.log("kloUser.hasKLOFeedback",kloUser.hasKLOFeedback)
  return (
    window.innerWidth > 1300 && kloUser && kloUser.user && kloUser.user.IS_BANK && kloUser.showBankSelect === true && Array.isArray(kloUser.banks) 
      ?
      <Grid container item  className={classes.bankSelectContainer} style={{width:width}}>
        { kloUser.hasFeedback === false && 1 === 2
          ?
          <Grid item style= {{width: width - 270, justifyItems: 'center', display: 'flex',    alignItems: 'center', justifyContent: 'center'}}>
          Для Вас полезны данные из КЛО ?
          <IconButton						
						color="primary"
						aria-label="archive"
            onClick={(e) => saveFeedback('0')}
						//className={props.size ? classes[props.size] : classes.normal}
						//style={{ backgroundColor: 'rgb(255, 255, 255)' }}
					>
						<ThumbDownIcon style={{fill:'rgba(235, 80, 94, 0.53)'}} fill='#FFFFFF' />
					</IconButton>
          <IconButton						
						color="primary"
						aria-label="archive"
            onClick={(e) => saveFeedback('1')}
						//className={props.size ? classes[props.size] : classes.normal}
						//style={{ backgroundColor: 'rgb(255, 255, 255)' }}
					>
						<ThumbUpIcon fill={'rgba(0, 0, 0, 0.87'} style={{fill:'rgba(129, 211, 157, 1)'}} />
					</IconButton>
        </Grid>
        :
        null
        }
        {kloUser.banks.length > 0
        ?
        <CustomAutocomplete
        label ='Банк'
        id= 'Bselect'
        value = {kloUser.currentBank.name}
        onChange = {(event, newValue, index) => {          
          if ( index > -1 && kloUser.banks[index]) {
            localStorage.setItem('currentBank', kloUser.banks[index].serverParts[0].id);

            _kloUser((prevstate) => {return { ...prevstate, ['currentBank']:kloUser.banks[index], ['currentServerPart'] :kloUser.banks[index].serverParts[0].id }})
          }
        }}
        data ={kloUser.banks}
        //optionProp = {name}
        />
        :
        null
        }
        
      </Grid>
      :
      null


	
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: '100%',
    backgroundColor: '#F6F6FB',
    borderRadius: 16,
    boxShadow: 'none',
    padding: 24,
    height: 'fit-content',

    [theme.breakpoints.down(696)]: {
      padding: 0,
      backgroundColor: 'transparent',
    }
  },
  bankSelectContainer:{
    width:700,//'calc(100% - 342px)',
    display:'inline-flex',
    justifyContent:'flex-end'
  },
  kloLinkBuy:{
    color: 'rgb(129, 211, 157)', fontSize: '13px', lineHeight: '16px', fontFamily: 'Cera CY',
    display: 'flex',
    alignItems: 'center'
  },
  kloLinkNotBuy:{
    color: 'rgba(235, 80, 94, 1)', fontSize: '13px', lineHeight: '16px', fontFamily: 'Cera CY',
    display: 'flex',
    alignItems: 'center'
  },
  kloLinkTest:{
    color: 'rgba(254, 157, 103, 1)', fontSize: '13px', lineHeight: '16px', fontFamily: 'Cera CY',
    display: 'flex',
    alignItems: 'center'
  },
  kloLinkDec:{
    color: 'rgba(36, 38, 42, 1)', fontSize: '13px', lineHeight: '16px', fontFamily: 'Cera CY',
    display: 'flex',
    alignItems: 'center'
  },
  iconLinkBuy : {
    color:'rgba(129, 211, 157, 0.83)',
    width:14,
    height:14,
    marginRight:6
  },
  iconLinkTest : {
    color:'rgba(254, 157, 103, 1)',
    width:14,
    height:14,
    marginRight:6
  },iconLinkDec : {
    color:'rgba(254, 157, 103, 1)',
    width:14,
    height:14,
    marginRight:4
  },
  iconLinkNotBuy : {
    color:'rgba(61, 64, 71, 1)',
    width:14,
    height:14,
    marginRight:6
  },

  LinkType2:{
    // fontFamily: 'Cera CY',
    // fontStyle: 'normal',
    // fontWeight: 'normal',
    // fontSize: '16px',
    // lineHeight: '24px',
    // color: '#24262A',

    // '& * > a': {
      color: '#24262A !important',
      textDecoration: 'none',
      borderBottom: '1px solid rgba(0, 0, 0, 0.4)',

      '&:hover': {
        color: '#2050FF !important',
        textDecoration: 'none',
        borderBottom: '1px solid #2050FF',
      }}
}));